import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardContent, Grid, Fab, Typography, Box, Paper, Button, CircularProgress, Modal } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import { makeStyles } from '@mui/styles';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Tab from '@mui/material/Tab';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Swal from 'sweetalert2';
import CloseIcon from '@mui/icons-material/Close';


const useStyles = makeStyles(theme => ({
    floatRight: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    centrarContenido: {
        display: 'flex',
        justifyContent: 'center'
    },
    backGroundBox: {
        backgroundColor: '##e4f0ec!important'
    },
    backGroundBoxEliminado: {
        backgroundColor: '#E1E1E1!important'
    },
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        backgroundColor: 'white',
        padding: '0.2em 1.1em 1.1em 1.1em',
        borderRadius: '5px',
        "@media (max-width: 600px)": {
            width: '90%', // Ajusta el ancho para pantallas pequeñas
            padding: '1em', // Ajusta el padding para mejor visualización
        },
    },
    color_texto_aclaracion: {
        color: 'gray',
        fontSize: 1
    },
    mapContainer: {
        height: '100vh', width: '100%'
    },
    mapElements: {
        height: '100%'
    },
    tabPanelContainer: {
        width: '100%', 
        overflow: 'hidden' 
    },
    tabPanel: {
        width: '100%'        
    },
    ocultarBotonEditar: {
        display: "flex", // Mostrar los botones por defecto
        justifyContent: "flex-end", // Alinear a la derecha en pantallas grandes
        flexWrap: "nowrap", // No permitir que los botones se ajusten en pantallas grandes
        "@media (max-width: 600px)": {
            justifyContent: "center", // Centrar los botones en pantallas pequeñas
            flexWrap: "wrap", // Permitir que los botones se ajusten en pantallas pequeñas
        },
    },
    botonesResponsive: {
        marginRight: "0.5em", // Espaciado entre botones en pantallas grandes
        marginLeft: "50px",
        "@media (max-width: 600px)": {
            width: "100%", // Botones ocupan todo el ancho en pantallas pequeñas
            marginBottom: "0.5em", // Espaciado vertical entre botones en pantallas pequeñas
            marginRight: "0", // Eliminar margen derecho en pantallas pequeñas
            marginLeft: "50px"
        },
    },
}));




export const ModalDomicilio = ({ datos, setDatos, open, setOpenModalDomicilio, tipoCalleSelect, datosDocimilio, bloquearBtn, setTituloModal,setDatosDocimilio, setErrorTelefono, setOpen, setTipoDomicilio, setDomiciliosProfesionales, domiciliosProfesionales}) => {
    const clases = useStyles();
    const tpotramite = Number(localStorage.tpoTramite);

    let estilo = {};
    const renderSwitch = param => {
        switch (param) {
            case 1:
                estilo = { marginRight: '-30%', marginLeft: "22%" };
                return 'Particular';
            case 2:
                estilo = { marginRight: '-22%', marginLeft: "22%" };
                return 'Profesional';
            case 3:
                estilo = { marginRight: '-20%', marginLeft: "25%" };
                return 'Constituido';
            case 4:
                estilo = { marginRight: '-25%', marginLeft: "12%" };
                return 'Correspondencia';
            case 5:
                estilo = { marginRight: '-25%', marginLeft: "25%" };
                return 'Real Caja';
        }
    };
    
    const onClose = () => {
        setOpenModalDomicilio(false)
    }

    const handleConfirm = (tpoDomicilio) => {
        let erroresMostrar = "";
        let mostrarErrorDomicilio = 0;
        

        const domiciliosArr = [...datos.domicilios];
        const updatedDomiciliosProfesionales = { ...domiciliosProfesionales };
        // console.log('domiciliosProfesionales', domiciliosProfesionales)
        // console.log('domiciliosArr', domiciliosArr);
        
        domiciliosArr.map((domicilio, index) => {
            
            const errores = [];
            if (domicilio.tpoDomicilio === tpoDomicilio || domicilio.TpoDomicilio === tpoDomicilio){
                
                if(domicilio.localidad === "") errores.push("localidad");
                if (domicilio.calle === "") errores.push("calle");
                if (domicilio.celular === "" && tpotramite !== 3) errores.push("celular");
                //if (domicilio.caracteristica === null) errores.push("característica");
                if (!domicilio.caracteristica && tpotramite !== 3) errores.push("característica");
                if (domicilio.caracteristica && domicilio.caracteristica.length > 5 && tpotramite !== 3) errores.push("característica (longitud mayor a 5)");
                if (domicilio.caracteristicaFijo && domicilio.caracteristicaFijo.length > 5) errores.push("característica fija (longitud mayor a 5)");
                if (isNaN(domicilio.caracteristica) && tpotramite !== 3) errores.push("característica (no es un número)");
                if (isNaN(domicilio.celular) && tpotramite !== 3) errores.push("celular (no es un número)");
                
                if (errores.length > 0 && mostrarErrorDomicilio === 0) {
                    if (erroresMostrar !== "") erroresMostrar += ", ";
                    erroresMostrar += `<b>Domicilios</b>: ${errores.join(", ")}`;
                    mostrarErrorDomicilio = 1;
                }
                if (erroresMostrar === "") {
                    domicilio.confirmaDomicilio = true;
    
                    const key = Object.keys(domiciliosProfesionales).find(
                        (k) => domiciliosProfesionales[k].TpoDomicilio === tpoDomicilio
                    );
                    if (key) {
                        updatedDomiciliosProfesionales[key] = {
                            ...updatedDomiciliosProfesionales[key],
                            confirmaDomicilio: true,
                        };
                    }
                }
                //cambiar de tab +1 
            }
        })

        if (erroresMostrar !== "") {
            Swal.fire({
                title: 'Atención', html: 'Debe completar correctamente los siguientes datos:' + erroresMostrar, 
                icon: 'warning', showCloseButton: true, showCancelButton: false, 
                confirmButtonText: 'Aceptar', cancelButtonText: 'Cancelar', allowOutsideClick: true
            });
            return false;
        }



        // const domiciliosProfesionalesArr = domiciliosProfesionales.map((domicilios) => ({
        //     ...domiciliosProfesionales,
        //     confirmaDomicilio: true
        // }))


        // setDomiciliosProfesionales({
        //     ...datos.domicilios,

        // })

        setDatos({
            ...datos,
            domicilios: domiciliosArr
        });

        setDomiciliosProfesionales(updatedDomiciliosProfesionales); 
        
        setOpenModalDomicilio(false);
    
    }

    const handleOpen = TpoDomicilio => {
        TpoDomicilio = Number(TpoDomicilio);
        setTituloModal(renderSwitch(TpoDomicilio));
        let paso = 0;

        // console.log('datos Domicilio en el open', datos.domicilios);

        datos.domicilios.map((domicilio, index) => {
            if ((domicilio.TpoDomicilio === TpoDomicilio || (domicilio.TpoDomicilio === undefined && domicilio.tpoDomicilio === TpoDomicilio) || domicilio.TpoDomicilio === 0) && paso === 0) {
                setDatosDocimilio({
                    TpoDomicilio: TpoDomicilio,
                    localidad: domicilio.localidad !== null ? domicilio.localidad : '',
                    codLocalidad: domicilio.codLocalidad !== undefined ? domicilio.codLocalidad : '',
                    calle: domicilio.calle,
                    numero: domicilio.numero.trim(),
                    piso: domicilio.piso.trim(),
                    depto: domicilio.depto.trim(),
                    tpoCalle: domicilio.tpoCalle !== undefined ? domicilio.tpoCalle : 0,
                    delegacion: domicilio.delegacion !== null ? domicilio.delegacion : '',
                    codPostal: domicilio.codPostal,
                    partido: domicilio.partido !== null ? domicilio.partido : '',
                    provincia: domicilio.provincia !== null ? domicilio.provincia : '',
                    telefono: domicilio.telefono.trim(),
                    caracteristica: domicilio.caracteristica !== null ? domicilio.caracteristica : '',
                    caracteristicaFijo: domicilio.caracteristicaFijo !== null ? domicilio.caracteristicaFijo : '',
                    celular: domicilio.celular.trim(),
                    tpoCarga: 1 
                });

                paso = 1;
                return setDatosDocimilio;
            }
        });
        setErrorTelefono({ display: "none" });
        setOpen(true);
        setOpenModalDomicilio(false);
        setTipoDomicilio(Number(TpoDomicilio));
    };



  return (
    <Modal
        open={open}
        onClose={onClose}
    >
        <Box className={clases.modal}>
            {/* <CardContent> */}
                <Grid item container justifyContent="flex-end" >
                    <CloseIcon style={{ cursor: "pointer" }} onClick={() => setOpenModalDomicilio(false)} />
                </Grid>
                <Card variant='custom' sx={{ boxShadow: 5, background: '#e4f0ec', borderColor: '#b8daba', borderRadius: '5px', border: '3px solid #b8daba'}}>
                    <CardContent>
                        <Grid container >
                            <Grid item xs={12} className={clases.centrarContenido}>
                                <Grid  >
                                    <h3 style={{

                                        display: 'flex',
                                        alignItems: 'center',
                                        flexWrap: 'wrap',
                                    }}>  <HomeIcon /> {
                                            (datosDocimilio.TpoDomicilio !== undefined && datosDocimilio.TpoDomicilio !== 0) &&
                                            renderSwitch(datosDocimilio.TpoDomicilio)
                                        }
                                    </h3>
                                </Grid>                          
                                </Grid>
                                <Grid item md={6} sx={{ mb: 2 }} >
                                    Provincia: <b> {datosDocimilio.provincia}</b>
                                </Grid>
                                <Grid item md={6} sx={{ mb: 2 }} >
                                    Localidad: <b> {datosDocimilio.localidad}</b>
                                </Grid>
                                <Grid item md={4} sx={{ mb: 2 }} >
                                    Calle : <b> {datosDocimilio.calle}  {datosDocimilio.numero}</b>
                                </Grid>
                                <Grid item md={4} sx={{ mb: 2 }} >
                                    Tipo: <b> {datosDocimilio.tpoCalle !== undefined && datosDocimilio.tpoCalle !== 0 ? tipoCalleSelect.filter(e => e.value === datosDocimilio.tpoCalle)[0].label : ""}</b>
                                </Grid>
                                <Grid item md={2} sx={{ mb: 2 }} >
                                    Piso:<b> {datosDocimilio.piso}</b>
                                </Grid>
                                <Grid item md={2} sx={{ mb: 2 }} >
                                    Dpto.:<b> {datosDocimilio.depto}</b>
                                </Grid>
                                {
                                    (tpotramite === 3 && datosDocimilio.TpoDomicilio === 1) && (
                                        <Grid item md={4} sx={{ mb: 2 }} >
                                            Delegación: <b> {datosDocimilio.delegacion}</b>
                                        </Grid>
                                    )
                                }
                                <Grid item md={4} sx={{ mb: 2 }} >
                                    Cod. Postal: <b> {datosDocimilio.codPostal}</b>
                                </Grid>
                                <Grid item md={4} sx={{ mb: 2 }} >
                                    Partido: <b> {datosDocimilio.partido}</b>
                                </Grid>
                                <Grid item md={4}  >
                                    Fijo:  <b> {(datosDocimilio.caracteristicaFijo !== null && datosDocimilio.caracteristicaFijo !== "" && datosDocimilio.caracteristicaFijo !== undefined) && "(0" + datosDocimilio.caracteristicaFijo + ")"}{(datosDocimilio.telefono !== null && datosDocimilio.telefono !== "") && datosDocimilio.telefono}</b>
                                </Grid>
                                {
                                    tpotramite !== 3 &&
                                    <Grid item md={6} >
                                        Celular:  <b> {(datosDocimilio.caracteristica !== null && datosDocimilio.caracteristica !== "") && "(0" + datosDocimilio.caracteristica + ")"}{(datosDocimilio.celular !== null && datosDocimilio.celular !== "") && "15-" + datosDocimilio.celular}</b>
                                    </Grid>
                                }
                                {(localStorage.userType !== "1" && (bloquearBtn !== true)) &&
                                    <Grid item md={12} className={clases.ocultarBotonEditar}>
                                    <Grid
                                        sx={{
                                            position: "relative",
                                            justifyContent: "flex-end",
                                            display: "flex",
                                            mt: 1,
                                            mb: "1px",
                                            "@media (max-width: 600px)": {
                                                justifyContent: "center", // Centrar en pantallas pequeñas
                                            },
                                        }}
                                    >
                                        <Button
                                            disabled={bloquearBtn}
                                            onClick={() => handleOpen(Number(datosDocimilio.TpoDomicilio))}
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            className={clases.botonesResponsive}
                                        >
                                            Modificar
                                        </Button>
                                
                                        {!datosDocimilio.confirmaDomicilio && (
                                            <Button
                                                disabled={bloquearBtn}
                                                onClick={() => handleConfirm(Number(datosDocimilio.TpoDomicilio))}
                                                variant="contained"
                                                color="secondary"
                                                size="small"
                                                className={clases.botonesResponsive}
                                                sx={{ml: 2}}
                                            >
                                                Confirmar
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                                }
                            </Grid>
                    </CardContent>
                </Card>
            {/* </CardContent> */}
        </Box>
    </Modal>
  )
}
